/**
 * gallery.js — thư viện ảnh trang chi tiết sản phẩm (mục 15): bấm ảnh nhỏ để đổi ảnh lớn,
 * rê chuột để phóng to, bấm ảnh lớn / nút phóng to để xem toàn màn hình, mobile vuốt ngang.
 *
 * Markup: [data-gallery]
 *           img[data-gallery-main]                 ảnh lớn
 *           [data-gallery-placeholder][hidden]     ô sọc thay ảnh lớn khi ảnh phụ chưa có
 *           button[data-gallery-thumb][data-src][data-alt]   ảnh nhỏ có ảnh thật
 *           button[data-gallery-thumb][data-placeholder]     ảnh nhỏ còn là ô sọc (nhãn sau, hộp quà)
 *           button[data-gallery-expand]            mở lightbox ở ảnh đang xem
 *           [data-gallery-dots]                    (để trống) chấm vị trí cho mobile
 *         + .modal[data-gallery-lightbox] ở cuối trang: img[data-lightbox-image],
 *           [data-lightbox-placeholder], [data-lightbox-prev/next], [data-lightbox-count]
 * Ảnh nhỏ là <button> nên Tab tới và Enter/Space chạy sẵn; ảnh đang xem mang
 * aria-current="true" — CSS dựa vào đó để kẻ viền Red 700, không cần class riêng.
 * Mũi tên trái/phải trong hàng ảnh nhỏ (và khi lightbox mở) chuyển ảnh liền kề.
 *
 * Vì sao như vậy:
 *   · Phóng to chỉ bật trên thiết bị có chuột từ md 1024px (matchMedia) — trên cảm ứng không có hover,
 *     và chạm vào ảnh đã là mở lightbox.
 *   · Mobile ẩn hàng ảnh nhỏ (CSS .has-swipe) CHỈ khi script đã dựng chấm + vuốt, nên JS lỗi thì
 *     hàng ảnh nhỏ vẫn còn để xem ảnh khác.
 *   · Lightbox mở bằng window.WBModal (js/modal.js lo Esc, giữ focus, trả focus) — modal.js nạp sau
 *     file này nên chỉ gọi lúc bấm.
 *
 * WP: WooCommerce có sẵn flexslider + photoswipe (wc-product-gallery-slider / -zoom / -lightbox).
 * Giữ markup này trong override single-product/product-image.php và tắt cả ba add_theme_support
 * để hai bộ không giành nhau.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var SWIPE_MIN = 40; // px ngang tối thiểu để tính là vuốt, không phải chạm lệch tay
    // 1024px = mq(md) trong SCSS (khổ 2 cột của trang)
    var canZoom = window.matchMedia && window.matchMedia('(hover: hover) and (min-width: 1024px)');

    [].slice.call(document.querySelectorAll('[data-gallery]')).forEach(function (gallery) {
        var stage = gallery.querySelector('.pdp-gallery__stage');
        var main = gallery.querySelector('[data-gallery-main]');
        var placeholder = gallery.querySelector('[data-gallery-placeholder]');
        var thumbs = [].slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
        var dotsBox = gallery.querySelector('[data-gallery-dots]');
        var expand = gallery.querySelector('[data-gallery-expand]');
        var lightbox = document.querySelector('[data-gallery-lightbox]');
        if (!main || !thumbs.length) return;

        var current = 0;
        var dots = [];

        // Tải trước ảnh lớn của các ảnh nhỏ để đổi ảnh không bị nháy trắng
        thumbs.forEach(function (thumb) {
            var src = thumb.getAttribute('data-src');
            if (src && src !== main.getAttribute('src')) new Image().src = src;
        });

        function show(index) {
            index = (index + thumbs.length) % thumbs.length;
            current = index;
            var thumb = thumbs[index];
            var src = thumb.getAttribute('data-src');
            var label = thumb.getAttribute('data-placeholder');

            if (src) {
                main.setAttribute('src', src);
                main.setAttribute('alt', thumb.getAttribute('data-alt') || '');
                main.hidden = false;
                if (placeholder) placeholder.hidden = true;
            } else if (label && placeholder) {
                // Ảnh phụ chưa chụp: sân khấu hiện ô sọc cùng nhãn với ảnh nhỏ
                placeholder.textContent = label;
                placeholder.hidden = false;
                main.hidden = true;
            }

            thumbs.forEach(function (other, i) {
                if (i === index) {
                    other.setAttribute('aria-current', 'true');
                } else {
                    other.removeAttribute('aria-current');
                }
            });
            dots.forEach(function (dot, i) {
                dot.classList.toggle('is-current', i === index);
            });
            if (lightbox && lightbox.classList.contains('is-open')) renderLightbox();
        }

        thumbs.forEach(function (thumb, index) {
            thumb.addEventListener('click', function () {
                show(index);
            });

            thumb.addEventListener('keydown', function (event) {
                var step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
                if (!step) return;
                event.preventDefault();
                var next = (index + step + thumbs.length) % thumbs.length;
                thumbs[next].focus();
                show(next);
            });
        });

        // ----- Mobile: chấm vị trí + vuốt ngang trên sân khấu -----
        if (dotsBox && stage) {
            thumbs.forEach(function (thumb, i) {
                var dot = document.createElement('span');
                if (thumb.getAttribute('aria-current') === 'true') current = i;
                dotsBox.appendChild(dot);
                dots.push(dot);
            });
            dots[current].classList.add('is-current');
            gallery.classList.add('has-swipe');

            var startX = 0;
            var startY = 0;
            stage.addEventListener(
                'touchstart',
                function (event) {
                    startX = event.touches[0].clientX;
                    startY = event.touches[0].clientY;
                },
                { passive: true }
            );
            stage.addEventListener(
                'touchend',
                function (event) {
                    var dx = event.changedTouches[0].clientX - startX;
                    var dy = event.changedTouches[0].clientY - startY;
                    if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) < Math.abs(dy)) return;
                    show(current + (dx < 0 ? 1 : -1));
                    stage.setAttribute('data-swiped', '');
                },
                { passive: true }
            );
        }

        // ----- Desktop: phóng to theo con trỏ -----
        if (stage && canZoom) {
            var syncZoomable = function () {
                if (canZoom.matches) stage.setAttribute('data-gallery-zoomable', '');
                else stage.removeAttribute('data-gallery-zoomable');
            };
            syncZoomable();
            if (canZoom.addEventListener) canZoom.addEventListener('change', syncZoomable);

            stage.addEventListener('mousemove', function (event) {
                if (!canZoom.matches || main.hidden) return;
                var box = stage.getBoundingClientRect();
                stage.style.setProperty('--zx', ((event.clientX - box.left) / box.width) * 100 + '%');
                stage.style.setProperty('--zy', ((event.clientY - box.top) / box.height) * 100 + '%');
                stage.classList.add('is-zooming');
            });
            stage.addEventListener('mouseleave', function () {
                stage.classList.remove('is-zooming');
            });
        }

        // ----- Lightbox -----
        var lbImage = lightbox ? lightbox.querySelector('[data-lightbox-image]') : null;
        var lbPlaceholder = lightbox ? lightbox.querySelector('[data-lightbox-placeholder]') : null;
        var lbCount = lightbox ? lightbox.querySelector('[data-lightbox-count]') : null;

        function renderLightbox() {
            var thumb = thumbs[current];
            var src = thumb.getAttribute('data-src');
            if (lbImage) {
                lbImage.hidden = !src;
                if (src) {
                    lbImage.setAttribute('src', src);
                    lbImage.setAttribute('alt', thumb.getAttribute('data-alt') || '');
                }
            }
            if (lbPlaceholder) {
                lbPlaceholder.hidden = !!src;
                lbPlaceholder.textContent = thumb.getAttribute('data-placeholder') || '';
            }
            if (lbCount) lbCount.textContent = current + 1 + ' / ' + thumbs.length;
        }

        function openLightbox() {
            if (!lightbox || !window.WBModal) return;
            stage.classList.remove('is-zooming');
            renderLightbox();
            window.WBModal.open(lightbox);
        }

        if (lightbox) {
            if (expand) expand.addEventListener('click', openLightbox);

            if (stage) {
                stage.addEventListener('click', function (event) {
                    // Nút tim / nút phóng to nằm trên sân khấu — bấm chúng không mở lightbox
                    if (event.target.closest('button, a')) return;
                    // Vừa vuốt xong thì touchend cũng bắn click: bỏ qua lần đó
                    if (stage.hasAttribute('data-swiped')) {
                        stage.removeAttribute('data-swiped');
                        return;
                    }
                    openLightbox();
                });
            }

            var prev = lightbox.querySelector('[data-lightbox-prev]');
            var next = lightbox.querySelector('[data-lightbox-next]');
            if (prev) {
                prev.addEventListener('click', function () {
                    show(current - 1);
                });
            }
            if (next) {
                next.addEventListener('click', function () {
                    show(current + 1);
                });
            }

            document.addEventListener('keydown', function (event) {
                if (!lightbox.classList.contains('is-open')) return;
                if (event.key === 'ArrowRight') show(current + 1);
                else if (event.key === 'ArrowLeft') show(current - 1);
            });
        }
    });
})();
